import { render, staticRenderFns } from "./reportMessage.vue?vue&type=template&id=46412d0d&scoped=true&"
import script from "./reportMessage.vue?vue&type=script&lang=js&"
export * from "./reportMessage.vue?vue&type=script&lang=js&"
import style0 from "./reportMessage.vue?vue&type=style&index=0&id=46412d0d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46412d0d",
  null
  
)

export default component.exports